import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQueryWithoutProvider } from "@/redux/baseQuery";
import { Profile } from "@/redux/slices/profile/types";
import { transformProfile } from "../profile/helpers";

export const userAccountProfileApi = createApi({
  reducerPath: "userAccountProfileApi",
  baseQuery: baseQueryWithoutProvider("account-management"),
  endpoints: (builder) => ({
    getUserAccountProfile: builder.query<Profile, string>({
      query: (id) => `/${id}/profile`,
      transformResponse: transformProfile,
    }),
  }),
});

export const { useGetUserAccountProfileQuery } = userAccountProfileApi;
